import { render } from "./20221024.vue?vue&type=template&id=0dc2be8a"
import script from "./20221024.vue?vue&type=script&lang=js"
export * from "./20221024.vue?vue&type=script&lang=js"

import "./20221024.vue?vue&type=style&index=0&id=0dc2be8a&lang=scss&scope=true"

import exportComponent from "/mnt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__